// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  border: 3px dashed #ccc;
  border-radius: 12px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 40px;
  text-align: center;
}

.upload-area:hover {
  border-color: #0066cc;
  background: #f0f7ff;
}

.upload-area.drag-over {
  border-color: #0066cc;
  background: #e6f0ff;
  transform: scale(1.02);
}

.upload-area.loading {
  cursor: wait;
  pointer-events: none;
}

.upload-icon {
  color: #666;
  margin-bottom: 20px;
}

.upload-area:hover .upload-icon {
  color: #0066cc;
}

.upload-area h2 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #333;
}

.upload-area p {
  margin: 0 0 5px 0;
  color: #666;
}

.upload-hint {
  font-size: 12px;
  color: #999;
  margin-top: 15px !important;
}

.upload-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-loading .spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e0e0e0;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.upload-loading p {
  margin-top: 20px;
  color: #666;
}

.upload-error {
  margin-top: 20px;
  padding: 10px 20px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  color: #c00;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/UploadArea.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".upload-area {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 400px;\r\n  border: 3px dashed #ccc;\r\n  border-radius: 12px;\r\n  background: #fafafa;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  padding: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.upload-area:hover {\r\n  border-color: #0066cc;\r\n  background: #f0f7ff;\r\n}\r\n\r\n.upload-area.drag-over {\r\n  border-color: #0066cc;\r\n  background: #e6f0ff;\r\n  transform: scale(1.02);\r\n}\r\n\r\n.upload-area.loading {\r\n  cursor: wait;\r\n  pointer-events: none;\r\n}\r\n\r\n.upload-icon {\r\n  color: #666;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.upload-area:hover .upload-icon {\r\n  color: #0066cc;\r\n}\r\n\r\n.upload-area h2 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 24px;\r\n  color: #333;\r\n}\r\n\r\n.upload-area p {\r\n  margin: 0 0 5px 0;\r\n  color: #666;\r\n}\r\n\r\n.upload-hint {\r\n  font-size: 12px;\r\n  color: #999;\r\n  margin-top: 15px !important;\r\n}\r\n\r\n.upload-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.upload-loading .spinner {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 4px solid #e0e0e0;\r\n  border-top-color: #0066cc;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.upload-loading p {\r\n  margin-top: 20px;\r\n  color: #666;\r\n}\r\n\r\n.upload-error {\r\n  margin-top: 20px;\r\n  padding: 10px 20px;\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  border-radius: 6px;\r\n  color: #c00;\r\n  font-size: 14px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
